import React, { useRef } from 'react'
import {Form} from 'react-bootstrap'


const useCorrectionElements = () => {
    let correctionRefs = useRef([])

    /**
     * 
     * @param {string} transactionSysId unique id of transaction
     * @param {string} articleSysId unique id of articleType
     * @param {object[]} sizeEntries array with object containing a size string and an amount
     */
    const getCorrectionInputFields = (transactionSysId, articleSysId, sizeEntries, correctionRefs) => {
        return (
            <>
                {sizeEntries.map(entry =>
                    <td className="numberColumn">
                        <Form>
                            <Form.Control className="sizeAmount-correction" as="input" defaultValue="0" type="number" size="sm" ref={node => correctionRefs.current[transactionSysId + "__" + articleSysId + "__" + entry.SizeValue] = node} />
                        </Form>
                    </td>)
                }
            </>
        )
    }

    /**
     * Returns table columns consisting of correction values for sizes
     * @param {object[]} articleSizes array with size string and new correction amounts added
     */
    const getNewCorrectionValues = (articleSizes) => {
        return (
            <>
                {articleSizes.map(entry =>
                    entry.NewCorrectionAmount !== undefined ?
                        <td className="numberColumn">{(entry.NewCorrectionAmount > 0 ? "+" : "") + entry.NewCorrectionAmount}</td>
                        : null)
                }
            </>
        )
    }

    return { correctionRefs, getCorrectionInputFields, getNewCorrectionValues}
}

export {useCorrectionElements}